import { appConfig } from '../../../config/customization';
import { customerSupportTopbarSize } from '../../../constants/sizes';
import Device from '../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: appConfig.colors.errorScreenBackgroundColor,
    margin: '0 50px',
    overflow: 'auto',
    [Device.mobile]: {
      flexDirection: 'column'
    }
  },
  image: {
    height: 200,
    width: 'auto'
  },
  informationContainer: {
    width: 250,
    marginLeft: 20,
    textAlign: 'left'
  },
  totalHeight: {
    margin: 0,
    height: `calc(100% - ${customerSupportTopbarSize}px)`
  }
};
